export default __webpack_public_path__ + "static/media/Tr.13776d54.svg";